import { render, staticRenderFns } from "./Editor copy.vue?vue&type=template&id=6d73f77a&"
import script from "./Editor copy.vue?vue&type=script&lang=js&"
export * from "./Editor copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports